export default __webpack_public_path__ + "static/media/template_07.53813199.jpg";